import { render } from "./NewAlert.vue?vue&type=template&id=91377ab0"
import script from "./NewAlert.vue?vue&type=script&lang=js"
export * from "./NewAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__